import { hashString, memoize, unitless } from 'emotion-utils';

var hyphenateRegex = /[A-Z]|^ms/g;
var processStyleName = memoize(function (styleName) {
  return styleName.replace(hyphenateRegex, '-$&').toLowerCase();
});
var processStyleValue = function processStyleValue(key, value) {
  if (value == null || typeof value === 'boolean') {
    return '';
  }

  if (unitless[key] !== 1 && key.charCodeAt(1) !== 45 && // custom properties
  !isNaN(value) && value !== 0) {
    return value + 'px';
  }

  return value;
};
function handleInterpolation(interpolation) {
  if (interpolation == null) {
    return '';
  }

  switch (typeof interpolation) {
    case 'boolean':
      return '';

    case 'function':
      if (this === undefined) {
        return interpolation.toString();
      }

      return handleInterpolation.call(this, // $FlowFixMe
      interpolation(this.mergedProps, this.context));

    case 'object':
      if (interpolation.type === 2) {
        return interpolation.toString();
      }

      if (interpolation.styles !== undefined) {
        return interpolation.styles;
      }

      return createStringFromObject.call(this, interpolation);

    default:
      return interpolation;
  }
}

function createStringFromObject(obj) {
  var string = '';

  function _ref(interpolation) {
    string += handleInterpolation.call(this, interpolation);
  }

  function _ref2(key) {
    if (typeof obj[key] !== 'object') {
      string += processStyleName(key) + ":" + processStyleValue(key, obj[key]) + ";";
    } else {
      string += key + "{" + handleInterpolation.call(this, obj[key]) + "}";
    }
  }

  if (Array.isArray(obj)) {
    obj.forEach(_ref, this);
  } else {
    Object.keys(obj).forEach(_ref2, this);
  }

  return string;
}

var labelPattern = /label:\s*([^\s;\n{]+)\s*;/g;
var serializeStyles = function serializeStyles(args) {
  var styles = '';
  var identifierName = '';
  args.forEach(function (interpolation, i) {
    styles += handleInterpolation.call(this, interpolation);
  }, this);
  styles = styles.replace(labelPattern, function (match, p1) {
    identifierName += "-" + p1;
    return '';
  });
  var name = hashString(styles) + identifierName;
  return {
    styles: styles,
    name: name,
    type: 1,
    cls: "css-" + name
  };
};

export { processStyleName, processStyleValue, handleInterpolation, labelPattern, serializeStyles };
//# sourceMappingURL=index.es.js.map



// WEBPACK FOOTER //
// ./node_modules/@emotion/serialize/dist/index.es.js